import React, { useRef } from "react";
import { StudentFormProp } from "../../../../../../types/Forms";
import { Col, Input, Label, Row } from "reactstrap";
import { dynamicImage } from "../../../../../../utils";
import { AddProfile, PortfolioURL, ProjectDescriptionText } from "../../../../../../constants";

const ProfileForm: React.FC<StudentFormProp> = ({ formData, updateFormData, selectedImage, register, errors }) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const handleImageChange = () => {
    if (fileInputRef && fileInputRef.current) fileInputRef.current.click();
  };
  return (
    <Row className="g-3 avatar-upload">
      <Col xs="12">
        <div>
          <div className="avatar-edit">
            <Input {...register("imageUpload", { required: "Profile image is required" })} innerRef={fileInputRef} type="file" accept=".png, .jpg, .jpeg" onChange={updateFormData} />
            <Label htmlFor="imageUpload" onClick={handleImageChange} />
          </div>
          <div className="avatar-preview">
            <div id="image" style={{ backgroundImage: selectedImage ? `url(${selectedImage})` : `url(${dynamicImage}forms/user.png)` }} />
          </div>
        </div>
        <h6>{AddProfile}</h6>
        {errors.imageUpload && <span className="text-danger">{errors.imageUpload.message}</span>}
      </Col>
      <Col xs="12">
        <Label>{PortfolioURL}</Label>
        <Input {...register("portfolioURL", { required: "Portfolio URL is required" })} value={formData.portfolioURL} type="url" placeholder="https://zono" onChange={updateFormData} />
        {errors.portfolioURL && <span className="text-danger">{errors.portfolioURL.message}</span>}
      </Col>
      <Col xs="12">
        <Label>{ProjectDescriptionText}</Label>
        <Input {...register("projectDescription", { required: "Project Description is required" })} value={formData.projectDescription} type="textarea" onChange={updateFormData} rows={2}/>
        {errors.projectDescription && <span className="text-danger">{errors.projectDescription.message}</span>}
      </Col>
    </Row>
  );
};
export default ProfileForm;
